<template>
    <div>
        <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                <el-radio-group v-model="filters.ativo" size="small">
                    <el-radio-button :label="null">Todas</el-radio-button>
                    <el-radio-button :label="true">Ativas</el-radio-button>
                    <el-radio-button :label="false">Inativas</el-radio-button>
                </el-radio-group>
            </div>

            <div class="d-flex justify-content-end">
                <el-dropdown size="mini" split-button plain @command="handleSetOrder">
                    <strong>Ordenar</strong>: {{ filters.orderBy == 'latest' ? 'Recentes' : 'Antigas' }}
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="latest">
                            <div class="d-flex align-items-center">
                                <i class="el-icon-top mr-2"></i>
                                Mais Recentes
                            </div>
                        </el-dropdown-item>

                        <el-dropdown-item command="oldest">
                            <div class="d-flex align-items-center">
                                <i class="el-icon-bottom mr-2"></i>
                                Mais Antigas
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <el-table
            class="rounded"
            v-loading="loading"
            :data="data"
            align="center"
            border
        >
            <!-- Titulo -->
            <el-table-column label="Título" min-width="200" align="left">
                <template slot-scope="scope">
                    <span class="font-weight-bold">{{ scope.row.title }}</span>
                </template>
            </el-table-column>

            <!-- Mensagem -->
            <el-table-column label="Mensagem" min-width="260" align="left">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.body" placement="top" :open-delay="300">
                        <span class="d-inline-block text-truncate" :style="{ maxWidth: '240px' }">{{ scope.row.body }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>

            <!-- Frequencia -->
            <el-table-column label="Frequência" width="120" align="center">
                <template slot-scope="scope">
                    <el-tag size="small" type="info">{{ frequenciaLabel(scope.row.frequencia) }}</el-tag>
                </template>
            </el-table-column>

            <!-- Classe -->
            <el-table-column label="Classe" width="80" align="center">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.classe && scope.row.classe !== 'Todas'" size="small" type="primary">{{ scope.row.classe }}</el-tag>
                    <el-tag v-else size="small" type="success">TODAS</el-tag>
                </template>
            </el-table-column>

            <!-- Situacao -->
            <el-table-column label="Situação" width="100" align="left">
                <template slot-scope="scope">
                    <el-tag
                        size="small"
                        :type="scope.row.ativo ? 'success' : 'danger'"
                    >
                        {{ scope.row.ativo ? 'ATIVA' : 'INATIVA' }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- Enviar em -->
            <el-table-column label="Enviar em" width="160" align="left">
                <template slot-scope="scope">
                    <span v-if="scope.row.enviar_em">{{ formatDate(scope.row.enviar_em, true) }}</span>
                    <el-tag size="small" type="info">Não atribuído</el-tag>
                </template>
            </el-table-column>

            <!-- Proximo envio -->
            <el-table-column label="Próximo envio" width="160" align="left">
                <template slot-scope="scope">
                    <span v-if="scope.row.proximo_envio">{{ formatDate(scope.row.proximo_envio, true) }}</span>
                    <el-tag v-else size="small" type="info">Não atribuído</el-tag>
                </template>
            </el-table-column>

            <!-- Ultimo envio -->
            <el-table-column label="Último envio" width="160" align="left">
                <template slot-scope="scope">
                    <span v-if="scope.row.ultimo_envio">{{ formatDate(scope.row.ultimo_envio, true) }}</span>
                    <el-tag v-else size="small" type="info">Não atribuído</el-tag>
                </template>
            </el-table-column>

            <!-- Total de envios -->
            <el-table-column label="Total de envios" width="130" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.total_envios">{{ scope.row.total_envios }}</span>
                    <span v-else>0</span>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Acoes -->
            <el-table-column
                fixed="right"
                align="right"
                width="50"
            >
                <div slot="header" style="width: 100%;">
                    <i class="el-icon-menu" />
                </div>

                <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                        <el-popover placement="bottom-end" trigger="click">
                            <el-button
                                slot="reference"
                                size="mini"
                                type="info"
                                plain
                                circle
                                :disabled="loading"
                            >
                                <i class="el-icon-more"></i>
                            </el-button>

                            <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                                <span class="font-weight-bold">Ações</span>
                                <el-divider class="my-1"></el-divider>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        size="mini"
                                        type="success"
                                        plain
                                        @click="dispatchNotificacaoConfirmSubmit(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    >
                                        <i class="el-icon-right"></i>
                                        <span>Enviar</span>
                                    </el-button>
                                </div>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        size="mini"
                                        type="warning"
                                        plain
                                        @click="dispatchNotificacaoEdit(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    >
                                        <i class="el-icon-edit"></i>
                                        <span>Editar</span>
                                    </el-button>
                                </div>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        size="mini"
                                        type="danger"
                                        plain
                                        @click="dispatchNotificacaoDelete(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    >
                                        <i class="el-icon-delete"></i>
                                        <span>Excluir</span>
                                    </el-button>
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>

            <template slot="empty">
                <el-empty description="Nenhuma notificação disponível"></el-empty>
            </template>
        </el-table>

        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                    background
                    :current-page.sync="pagination.data.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="pagination.data.perPage"
                    layout="total, sizes, prev, pager, next"
                    :total="pagination.total"
                    @current-change="handlePageChange"
                    @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>

        <!-- NotificacaoEdit -->
        <NotificacaoEditModal ref="notificacaoEdit" @updated="fetch"/>

        <!-- NotificacaoConfirmSubmit -->
        <NotificacaoConfirmSubmitModal ref="notificacaoConfirmSubmit"/>

        <!-- DeleteModal -->
        <NotificacaoDeleteModal ref="notificacaoDelete" @deleted="fetch"/>
    </div>
</template>

<script>
    // Components
    import {
        Empty,
        Table,
        TableColumn,
        Notification,
        Popover,
        Tag,
        Divider,
        Tooltip,
        RadioGroup,
        RadioButton,
        Dropdown,
        DropdownMenu,
        DropdownItem,
    } from "element-ui";

    import NotificacaoCreateModal from "./NotificacaoCreateModal.vue";
    import NotificacaoEditModal from "./NotificacaoEditModal.vue";
    import NotificacaoConfirmSubmitModal from "./NotificacaoConfirmSubmitModal.vue";
    import NotificacaoDeleteModal from "./NotificacaoDeleteModal.vue";

    // Api
    import { NotificacaoApi } from "@/api/NotificacaoApi";
    const notificacaoApi = new NotificacaoApi();

    // Utils
    import { formatDate } from "@/util/formatters";

    export default {
        name: "notificacao-list",
        data() {
            return {
                data: [],
                loading: false,
                filters: {
                    ativo: null,
                    orderBy: 'latest',
                },
                frequencias: {
                    sem_limite: 'Sem limite',
                    diaria: 'Diária',
                    semanal: 'Semanal',
                },
                pagination: {
                    data: {
                        currentPage: 1,
                        perPage: 15,
                    },
                    pageSizes: [15, 50, 75, 100],
                    total: 0
                },
            }
        },
        methods: {
            async fetch() {
                try {
                    this.loading = true;

                    const res = await notificacaoApi.list({
                        ...this.filters,
                        ...this.pagination.data
                    });

                    this.data = res.data;
                    this.pagination.total = res.total;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter as notificações!'
                    });
                } finally {
                    this.loading = false;
                }
            },
            /**
             * Editar
             */
            async dispatchNotificacaoEdit(id) {
                this.$refs.notificacaoEdit.id = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.notificacaoEdit.show();

                elLoading.close();

                return this.$refs.notificacaoEdit.toggleModal();
            },

            /**
             * Confirmar envio
             */
            async dispatchNotificacaoConfirmSubmit(id) {
                this.$refs.notificacaoConfirmSubmit.selectedId = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.notificacaoConfirmSubmit.show();

                elLoading.close();

                return this.$refs.notificacaoConfirmSubmit.toggleModal();
            },

            /** Excluir */
            async dispatchNotificacaoDelete(id) {
                this.$refs.notificacaoDelete.id = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.notificacaoDelete.show();

                elLoading.close();

                return this.$refs.notificacaoDelete.toggleModal();
            },

            /**
             * Filters
             */
            handleSetOrder(orderBy) {
                this.filters.orderBy = orderBy;
            },

            /*
             * Pagination
             */
            handlePageChange(page) {
                this.pagination.data.currentPage = page;
                this.fetch();
            },
            handleSizeChange(val) {
                this.pagination.data.perPage = val;
                this.pagination.data.currentPage = 1;
                this.fetch();
            },
            /** Utils */
            formatDate,
            frequenciaLabel(value) {
                return this.frequencias[value] ?? value ?? '—';
            },
        },
        watch: {
            "filters": {
                deep: true,
                handler() {
                    this.pagination.data.currentPage = 1;
                    this.fetch();
                },
            }
        },
        mounted() {
            this.fetch();
        },
        components: {
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Notification.name]: Notification,
            [Popover.name]: Popover,
            [Tag.name]: Tag,
            [Divider.name]: Divider,
            [Tooltip.name]: Tooltip,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            NotificacaoCreateModal,
            NotificacaoEditModal,
            NotificacaoDeleteModal,
            NotificacaoConfirmSubmitModal,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/notificacao/NotificacaoList.vue